<template>
  <div>
    <div
      class="overflow-hidden flex justify-center items-center circle border border-solid border-black"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleWindow',
};
</script>

<style lang="scss" scoped>
.circle {
  border-radius: 50%;
  width: 68vw;
  height: 68vw;
}
</style>
